import { render, staticRenderFns } from "./add.vue?vue&type=template&id=2cb02bdd&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "@/pages/announcement/common/style/add.scss?vue&type=style&index=0&id=2cb02bdd&lang=scss&scoped=true&external"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&lang=css&external"
import style2 from "./add.vue?vue&type=style&index=2&id=2cb02bdd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb02bdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb02bdd')) {
      api.createRecord('2cb02bdd', component.options)
    } else {
      api.reload('2cb02bdd', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=2cb02bdd&scoped=true", function () {
      api.rerender('2cb02bdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/announcement/add.vue"
export default component.exports